import { Trans, useTranslation } from 'react-i18next';
import { FontWeight, Heading, LiliButton, Text } from '@lili/lili-frontend-common';
import { ILiliPlan } from '../../types';
import { convertValueToUSD, formatValueWithoutCurrency } from '../../../../helpers/currency.helper';

interface PlanInfoViewProps {
  plan: ILiliPlan;
  onUpgradeClick: (plan: ILiliPlan) => void;
  isLoading: boolean;
  disabled: boolean;
  isAnnual: boolean;
}
export const PlanInfoView = ({ plan, onUpgradeClick, isLoading, disabled, isAnnual }: PlanInfoViewProps) => {
  const { t } = useTranslation();
  const priceBeforeDiscount = plan.annualData ? plan.annualData?.priceBeforeDiscount : undefined;
  const price = isAnnual && plan.annualData ? plan.annualData.price : plan.price;
  const formattedPrice = formatValueWithoutCurrency(price, 2);

  return (
    <div className='w-[422px] flex-col flex h-full  items-center pt-[34px] gap-[24px]'>
      <Heading.H4 fontWeight={FontWeight.MEDIUM} className='text-center'>
        {plan.name}
      </Heading.H4>
      <div className='flex items-center flex-col gap-[16px]'>
        <span className='flex flex-row text-action03'>
          <Heading.H5 fontWeight={FontWeight.MEDIUM} className='text-inherit self-start'>
            $
          </Heading.H5>
          <Heading.H1 fontWeight={FontWeight.MEDIUM} className='text-inherit leading-[40px]'>
            {formattedPrice}
          </Heading.H1>
          <Heading.H10 fontWeight={FontWeight.MEDIUM} className='text-inherit self-end'>
            {isAnnual ? t('PLAN_UPGRADE.PLAN_PICKER.PRICE_PER_YEAR') : t('PLAN_UPGRADE.PLAN_PICKER.PRICE_PER_MONTH')}
          </Heading.H10>
        </span>
        {isAnnual && priceBeforeDiscount && (
          <Text.H10 fontWeight={FontWeight.MEDIUM} className='text-text-main-tertiary'>
            <Trans
              i18nKey='PLAN_UPGRADE.PLAN_PICKER.PREV_PRICE'
              t={t}
              values={{
                priceBeforeDiscount: convertValueToUSD(priceBeforeDiscount, 2),
              }}
              components={{ span: <span /> }}
            />
          </Text.H10>
        )}
      </div>
      <LiliButton
        isLoading={isLoading}
        id='planPickerTab'
        title={t('PLAN_UPGRADE.PLAN_PICKER.UPGRADE_BUTTON')}
        onClick={() => onUpgradeClick(plan)}
        className='w-[314px] h-[64px]'
        disabled={disabled}
      />
      <Text.H10 className='text-center'>{t('PLAN_UPGRADE.PLAN_PICKER.NO_MIN_DEPOSIT')}</Text.H10>
      <Text.H10 fontWeight={FontWeight.MEDIUM} className='w-[352px] text-center'>
        {plan.description}
      </Text.H10>
    </div>
  );
};
